module.exports = __webpack_public_path__ + "img/sp-icon-back-new.c08c02c0.svg";